<div id="wrap" class="moWrap">
  <header class="header">
      <div class="header_inner">
          <h1 class="header_logo">
              <a href="" class="logo"><img src="/assets/images/web/logo/logo_348.png" alt="OASIS BUDDY" /></a>
          </h1>
          <span class="util_right">
              <a href="https://www.oasis.co.kr" target="_blank" class="btn_oasis ico_blank">오아시스마켓</a>
          </span>
      </div>
  </header>

  <div id="content">
      <div id="skip_anchor" class="content page_login">
          <div class="login_area">
              <strong class="account_title">로그인</strong>
              <fieldset>
                  <div class="login_form">
                      <label for="aaaa">아이디</label>
                      <input type="text" id="aaaa" [(ngModel)]="userId" autocomplete="off" (keyup)="check()" (keyup.enter)="login()" class="form_input required" placeholder="아이디를 입력해 주세요."/>
                  </div>
                  <div class="login_form">
                      <label for="bbbbb">비밀번호</label>
                      <input type="password" id="bbbbb" [(ngModel)]="password" autocomplete="new-password" (keyup)="check()" (keyup.enter)="login()" class="form_input required" placeholder="비밀번호를 입력해 주세요."/>
                  </div>
                  <div class="btn" >
                      <button class="btn_item btn_required" [disabled]="!isActive" (click)="login()">로그인 하기</button>
                  </div>
                  <div class="login_info">
                      <a routerLink="/find/id" class="btn_info">아이디찾기</a>
                      <a routerLink="/find/pw" class="btn_info">비밀번호 재발급</a>
                      <a routerLink="/join" class="btn_info"><b>회원가입</b></a>
                  </div>
              </fieldset>
          </div>

          <div class="banner" *ngIf="isShowEventBanner">  <!-- 20250531 해당 영역 비노출 -->
            <a routerLink="/m/event"><img src="https://oasisprodcom.edge.naverncp.com/buddy/event/event_250415/mobile/banner.png" alt="EVENT. 최대 2만 포인트 보장. 버디챌린지하면 무조건 포인트 지급!" /></a>
          </div>

          <div class="login_cont1">
              <strong>
                <img *ngIf="isShowEventBanner" src="/assets/images/mobile/img/img_login_cont1_0415.png" alt="오아시스버디만의 특별한 혜택 안내" />
                <img *ngIf="!isShowEventBanner" src="/assets/images/mobile/img/img_login_cont1_0531.png" alt="오아시스버디만의 특별한 혜택 안내" />
              </strong>
              <div class="blind">
                  <!-- <strong>수수료 최대 5%!</strong>
                  <p>높은 수수료로 더 큰 수익! <br />업계 최고 수준의 수수료를 제공합니다.</p>
                  <div>
                      <strong>익월 정산 시스템</strong>
                      <p>익월 정산 시스템을 통해 <br />더 빠르고 편리한 정산&지급 혜택 제공</p>
                  </div>
                  <div>
                      <strong>별도 계약 가능</strong>
                      <p>오아시스마켓 전용 광고 크리에이터 계약 시 <br />다양한 광고 매칭 및 월 고정급여 제공</p>
                  </div>
                  <div>
                      <strong>채널 및 컨텐츠 홍보</strong>
                      <p>마케팅 및 판매 등 다양한 면에서 <br />지속적인 지원 제공</p>
                  </div> -->

                  <!-- <ol> img_login_cont1_0201.jpg
                    <li>
                      <strong>1. 리워드 최대 10%!</strong>
                      <p>내가 공유한 버디 링크를 통해 구매가 발생하면 총 결제금액의 최대 10%를 리워드로 받을 수 있어요.</p>
                      <em>추가혜택</em>
                      <ol>
                        <li>링크를 생성한 제품을 사지 않아도 링크를 통해 판매가 이루어진 모든 제품에 대해 리워드를 지급해 드립니다.</li>
                        <li>버디 링크를 통해 신규 회원 가입 시 첫 결제금액에 대해서 동일한 리워드를 지급해 드립니다.</li>
                      </ol>
                      <span>2/1 ~ 4/30 (3개월 한정)</span>
                    </li>
                    <li>
                      <strong>2. 익월 정산 시스템</strong>
                      <p>타사 정산 프로세스 대비 더 빠른 지급 혜택 제공 (ex. 발생(1월) -> 지급일(2월 20일)</p>
                    </li>
                    <li>
                      <strong>3. 소수정예 별도 계약 가능</strong>
                      <p>기여도에 따라 계약을 통한 광고 및 공구 진행, 수수료 인상 및 월 급여 제공 가능</p>
                      <p>*기여도 기준은 버디 활동을 통한 영향력 정도, 구매 전환 수, 활동 빈도 수 등을 종합적으로 판단합니다.</p>
                    </li>
                    <li>
                      <strong>4. SNS 채널 및 컨텐츠 홍보 지원</strong>
                      <p>마케팅 및 판매, 이벤트 등 지속적인 지원 제공</p>
                    </li>
                  </ol> -->

                  <ol>
                    <li>
                      <strong>1. 업계 최고 수준의 수수료! 최대 20% 리워드 (~5/30 까지)</strong>
                      <p>SNS 채널 및 컨텐츠 등에 공유한 버디링크를 통하여 구매가 이루어진 모든 제품에 대하여 리워드 지급</p>
                    </li>
                    <li>
                      <strong>2. 익월 정산 시스템</strong>
                      <p>타사 정산 프로세스 대비 더 빠른 지급 ex. 발생월(1월) 〉 지급월(2월 20일)</p>
                    </li>
                    <li>
                      <strong>3. 기여도에 따른 별도계약 가능</strong>
                      <p>버디 활동을 통한 영향력 정도를 종합적으로 판단하여 수수료 인상 및 월 급여, 광고&공구 진행</p>
                    </li>
                    <li>
                      <strong>4. SNS 채널 및 컨텐츠 홍보 지원</strong>
                      <p>마케팅 및 판매, 이벤트 등 지속적인 지원 제공</p>
                    </li>
                  </ol>
                  <p>*기여도 기준은 버디 활동을 통한 영향력 정도, 구매전환 수, 활동 빈도 수 등을 종합적으로 판단합니다.</p>
              </div>
          </div>

          <div class="login_cont2">
              <strong><img src="/assets/images/mobile/img/img_login_cont2_0201.jpg" alt="리워드는 어떻게 받나요?" /></strong>
              <div class="blind">
                  <!-- <p>회원 가입 후 광고를 원하는 상품을 검색 후 오아시스에서 제공하는 상품링크를 본인의 SNS, 채널 등에 노출 시켜 구매를 유도합니다. <br />링크를 통해 상품 판매가 이루어지면 구매액의 최대 5%를 제공합니다. <br /><b>(&#42;우대조건 :식품 관련 SNS 채널 운영자 / 오아시스마켓 장보기 및 요리 레시피 컨텐츠 창작자 등) </b></p>
                  <ol>
                      <li>
                          <em>STEP 1</em>
                          <p>본인의 SNS, 유튜브, 기타 채널 등에 오아시스마켓의 <br />광고를 노출시켜 주세요.</p>
                      </li>
                      <li>
                          <em>STEP 2</em>
                          <p>방문자가 게시된 광고를 클릭하고 <br />오아시스마켓에서 구매 합니다.</p>
                      </li>
                      <li>
                          <em>STEP 3</em>
                          <p>광고를 클릭한 방문자가 구매한 금액의 최대 5%를 <br />오아시스버디의 수익으로 지급합니다.</p>
                      </li>
                  </ol> -->

                  <strong>리워드는 어떻게 받나요?</strong>
                  <ol>
                      <li>
                          <em>STEP 1 버디 링크 생성</em>
                          <p>오아시스마켓에서 판매하는 상품의 버디 링크를 생성 후 자신의 SNS 채널에 컨텐츠와 함께 업로드 합니다.</p>
                          <p>버디 링크는 http://buddy.oasis.co.kr/ 형태로 표기됩니다.</p>
                      </li>
                      <li>
                          <em>STEP 2 상품 구매 발생</em>
                          <p>방문자가 SNS 채널에 게시된 버디 링크를 클릭 후 상품을 구매합니다.</p>
                      </li>
                      <li>
                          <em>STEP 3 리워드 정산</em>
                          <p>발생한 결제금액의 최대 10%를 리워드로 지급받을 수 있습니다.(자세한 이용 방법은 상단 '이용가이드'를 통해 확인하실 수 있습니다.</p>
                      </li>
                  </ol>
              </div>
          </div>

          <div class="login_cont cont4">
            <video src="https://oasisprodcom.edge.naverncp.com/buddy/video/video_250212.mp4" type="video/mp4" controls="" style="width:100%" poster="https://oasisprodcom.edge.naverncp.com/buddy/video/poster_250212.jpg"></video>
          </div>

          <div class="login_cont3">
              <strong>
                <img *ngIf="isShowEventBanner" src="/assets/images/mobile/img/img_login_cont3_0415.png" alt="오아시스버디 등급별 혜택 안내" />
                <img *ngIf="!isShowEventBanner" src="/assets/images/mobile/img/img_login_cont3_0531.png" alt="오아시스버디 등급별 혜택 안내" />
              </strong>
              <div class="blind">
                  <!-- <ul>
                      <li>
                          <em>이웃등급 3%</em>
                          <b>구매 금액의 3%를 리워드로 제공</b>
                          <ul>
                            <li>유튜브 구독자 100명 이상</li>
                            <li>인스타그램 팔로워 300명 이상</li>
                            <li>네이버 블로그 개설일 90일 이상</li>
                          </ul>
                          <p>조건 중 1개 이상 해당되는 계정</p>
                      </li>
                      <li>
                          <em>파워등급 5%</em>
                          <b>구매 금액의 5%를 리워드로 제공</b>
                          <ul>
                            <li>유튜브 구독자 1,000명 이상</li>
                            <li>인스타그램 팔로워 1,000명 이상</li>
                            <li>네이버 블로그 개설일 90일 이상</li>
                            <li>블로그 일 평균 방문자 10,000명 이상</li>
                          </ul>
                          <p>조건 중 1개 이상 해당되는 계정</p>
                      </li>
                  </ul>
                  <p>등급 별 추가 혜택(장보기포인트, 활동비 등)은 준비 중으로 순차적으로 업데이트될 예정입니다.</p> -->

                  <strong>EVENT 이벤트 기간(~2025.5.30) 동안 오아시스버디라면 누구나 구매금액의 20% 리워드!</strong>
                    <ul>
                        <li>
                            <em>이웃등급</em>
                            <b>구매 금액의 20%를 리워드로 제공</b>
                            <ul>
                              <li>유튜브 구독자 1천명 이상</li>
                              <li>인스타그램 팔로워 1천명 이상</li>
                              <li>블로그 직전월 순방문자 1만명 이상</li>
                            </ul>
                        </li>
                        <li>
                            <em>파워등급</em>
                            <b>구매 금액의 20%를 리워드로 제공</b>
                            <ul>
                              <li>유튜브 구독자 1만명 이상</li>
                              <li>인스타그램 팔로워 1만명 이상</li>
                              <li>블로그 직전월 순방문자 10만명 이상</li>
                            </ul>
                        </li>
                    </ul>
                    <em>안내사항</em>
                    <ul>
                      <li>버디 참여도 및 기여도에 따라 매 월 장보기 포인트 30,000원이 지급됩니다.</li>
                      <li>채널 영향력에 따라 등급이 부여되나 활동 여부 및 기여도에 따라 변경될 수 있습니다.</li>
                      <li>채널이 성장한 경우에는 등급 변경 신청이 가능합니다.</li>
                      <li>미활동 기간이 3개월을 초과할 시 비활성화 및 탈퇴처리 될 수 있습니다.</li>
                    </ul>
              </div>
          </div>
      </div>
  </div>
  <footer class="footer">
    <div class="footer_inner">
        <div class="footer_menu">
            <a routerLink="/m/guide">이용가이드</a>
            <a href="https://www.oasis.co.kr/help/privacy" target="_blank" title="새창" class="emphasis">개인정보처리방침</a>
            <a routerLink="/terms">약관 및 정책</a>
        </div>
    </div>
  </footer>
</div>
